<template>
  <layout-blank>
    <slot></slot>

    <Snackbar />
  </layout-blank>
</template>

<script>
import LayoutBlank from '@/@core/layouts/variants/blank/LayoutBlank.vue'

export default {
  components: {
    LayoutBlank,
  },
  setup() {
    return {}
  },
}
</script>

<style>
</style>
